import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { JournalEntryForm } from '@/features/accounting/components/JournalEntryForm';
import { useEffect, useState } from 'react';

export const Route = createFileRoute('/apps/accounting/entries/new')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
  component: NewEntryPage,
});

function NewEntryPage() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    // Open dialog immediately on mount
    setOpen(true);
  }, []);

  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen);
    if (!isOpen) {
      // Navigate back to entries list when dialog closes
      navigate({ to: '/apps/accounting/entries' });
    }
  };

  return (
    <DashboardLayout>
      <JournalEntryForm open={open} onOpenChange={handleOpenChange} />
    </DashboardLayout>
  );
}
